import { FACE_APPROVAL_FAILED, FACE_APPROVAL_REQUEST, FACE_APPROVAL_SUCCESS } from "app/redux/Approval/FaceApproval/constant";

const INIT_STATE = {
    loading: false,
    totalPage: 0,
    data: [],
    error: {
        isError: false,
        message: null
    }
};

export const faceApprovalReducer = function (state = INIT_STATE, action) {
    switch (action?.type) {
        case FACE_APPROVAL_REQUEST:
            return {
                loading: true,
                totalPage: 0,
                data: [],
                error: {
                    isError: false,
                    message: null
                }
            }
        case FACE_APPROVAL_SUCCESS:
            return {
                loading: false,
                data: action?.payload?.data,
                totalPage: action?.payload?.totalPage,
                error: {
                    isError: false,
                    message: null
                }
            }
        case FACE_APPROVAL_FAILED:
            const { isError = true, message = "Something Went Wrong" } = action?.payload?.error || {}
            return {
                loading: false,
                totalPage: 0,
                data: [],
                error: {
                    isError: isError,
                    message: message
                }
            }
        default:
            return state;
    }
};